import React from "react";
import { useNavigate } from "react-router-dom";
import "./BillingAlertBanner.css";
import { useAuth } from "../../../firebase/AuthProvider";
import { SubscriptionStatus } from "../../../Data/SD";
import { ROUTES } from "../../../Data/Routes/Routes";


const BillingAlertBanner: React.FC = () => {
    const navigate = useNavigate();

    const {
        subscriptionDetails,
        currentRoles,
        currentOrganizationRoles,
    } = useAuth();

    const subscriptionStatus = subscriptionDetails?.subscriptionStatus;

    // ✅ derive isOwner from roles
    const isOwner =
        (currentRoles &&
            currentRoles.some(
                (role) => role.name === "OWNER" || role.name === "ADMIN"
            )) ||
        currentOrganizationRoles?.some(
            (role) => role.systemKey === "ORG_OWNER"
        );

    if (
        !subscriptionStatus ||
        subscriptionStatus === SubscriptionStatus.ACTIVE ||
        subscriptionStatus === SubscriptionStatus.TRIAL_ACTIVE
    ) {
        return null;
    }

    const isTrialExpired =
        subscriptionStatus === SubscriptionStatus.READ_ONLY_TRIAL_EXPIRED;

    const isDelinquent =
        subscriptionStatus === SubscriptionStatus.READ_ONLY_DELINQUENT;

    if (!isTrialExpired && !isDelinquent) {
        return null;
    }

    const getMessage = () => {
        if (isTrialExpired) {
            return isOwner
                ? "Your trial has ended. Please add a payment method to continue using all features."
                : "This workspace is in read-only mode because the trial has ended. Please contact your Owner.";
        }

        if (isDelinquent) {
            return isOwner
                ? "Payment failed. Please update your billing details to restore full access."
                : "This workspace is in read-only mode due to a billing issue. Please contact your Owner.";
        }

        return "";
    };

    const handleNavigate = () => {
        navigate(ROUTES.BillingDetails());
    };

    const isReadOnly =
        subscriptionStatus === SubscriptionStatus.READ_ONLY_TRIAL_EXPIRED ||
        subscriptionStatus === SubscriptionStatus.READ_ONLY_DELINQUENT;

    if (!subscriptionStatus || !isReadOnly) {
        return null;
    }

    return (
        <div className="billing-banner">
            <span className="billing-message">{getMessage()}</span>

            {isOwner && (
                <button className="billing-button" onClick={handleNavigate}>
                    Go to Billing Settings
                </button>
            )}
        </div>
    );
};

export default BillingAlertBanner;